// Marcar MAIS DE UMA opção no mesmo filtro da Busca Avançada.
//
// ## O pedido
//
// "Na busca avançada do Kanban, permitir marcar mais de uma opção no mesmo
// filtro (ex.: prioridade, canal e categoria). Assim não é preciso criar
// vários Kanbans só para mudar a combinação de filtros." (Gisele, ponto 11 de
// 27/10/2026.)
//
// ## Por que um util, e não um `Array.includes` em cada campo
//
// O mesmo valor é lido em TRÊS lugares -- o modal que desenha, o filtro que
// decide o que a tela mostra e a tradução das condições para o servidor -- e
// cada um tem de concordar sobre o que é "nada selecionado". É o padrão de
// duas fontes que já custou caro nesta tela.
//
// E há um detalhe que morde: o estado antigo, gravado quando o campo era de
// escolha única, é uma STRING. Ele volta do `localStorage` dos operadores que
// já usavam a busca avançada antes desta mudança (os refinamentos passaram a
// sobreviver a fechar o navegador no ponto 12). Quem não tratar isso vê o
// filtro antigo deixar de funcionar sem erro nenhum.

/**
 * O valor de um filtro como LISTA, venha ele como lista, string ou vazio.
 *
 * @param {*} valor o que está guardado no estado do modal
 * @returns {Array} as opções escolhidas, sem vazios
 */
export function comoLista(valor) {
    const bruto = Array.isArray(valor) ? valor : [valor];

    return bruto.filter((v) => v !== null && v !== undefined && v !== '');
}

/** Há alguma opção marcada neste campo? */
export function temSelecao(valor) {
    return comoLista(valor).length > 0;
}

/**
 * O valor do chamado casa a seleção?
 *
 * Seleção vazia casa TUDO -- é "filtro não preenchido", e não "filtro que não
 * aceita nada". Sem isso, abrir a busca avançada sem escolher nada esvaziaria
 * a tela.
 *
 * @param {*} valorDoChamado o valor no chamado
 * @param {*} selecao o que está marcado no filtro
 * @param {object} [opcoes]
 * @param {boolean} [opcoes.ignorarCaixa] compara sem diferenciar maiúsculas
 * @returns {boolean}
 */
export function casaSelecao(valorDoChamado, selecao, opcoes = {}) {
    const escolhidos = comoLista(selecao);

    if (escolhidos.length === 0) return true;
    if (valorDoChamado === null || valorDoChamado === undefined || valorDoChamado === '') return false;

    const normaliza = (v) => (opcoes.ignorarCaixa ? String(v).toLowerCase() : v);
    const alvo = normaliza(valorDoChamado);

    return escolhidos.some((escolhido) => {
        if (opcoes.ignorarCaixa) return normaliza(escolhido) === alvo;

        /*
         * Frouxa de propósito no caminho sem `ignorarCaixa`: a prioridade
         * chega número do chamado (0 a 3) e o `<Select>` do MUI devolve o
         * que estiver no `value` do item, que já veio string em alguns
         * caminhos. Comparar com `===` faria "Alta" nunca casar, sem erro.
         */
        /* eslint-disable-next-line eqeqeq */
        return escolhido == valorDoChamado;
    });
}

export default casaSelecao;
